export const DEFAULT_STATUS_FILTER = [
    {
        value: "new",
        label: "Nouveau",
    },
    {
        value: "approved",
        label: "Accepté",
    },
    {
        value: "rejected",
        label: "rejeté",
    },
    // {
    //     value: "closed",
    //     label: "fermé",
    // },
];

export const DEFAULT_START_DATE: string = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().slice(0, 10);
export const DEFAULT_END_DATE: string = new Date().toISOString().slice(0, 10);

export const DEFAULT_RADIUS: number = 500;
export const PAGINATION_NUMBER_PER_PAGE: number = 15;
export const SORT_FIELD_DEFAULT: string = 'createdAt';
export const SORT_ORDER_DEFAULT: string = 'desc';

export const ADVANCED_FILTERS_TYPES = {
    ADDRESS: 'address',
    REQUEST_TYPES: 'requestTypes',
    STATUS: 'status',
    RADIUS: 'radius',
};
